import { render } from "./userDetail.vue?vue&type=template&id=a28ed514&scoped=true&ts=true"
import script from "./userDetail.vue?vue&type=script&lang=ts"
export * from "./userDetail.vue?vue&type=script&lang=ts"

import "./userDetail.vue?vue&type=style&index=0&id=a28ed514&scoped=true&lang=scss"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a28ed514"]])

export default __exports__